(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yb-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var tiers = JSON.parse(root.dataset.tiers || "[]"), picked = [];
    var money = function (c) { return window.YB && YB.money ? YB.money(c) : (c / 100).toFixed(2); };
    var slots = root.querySelector("[data-bb-slots]"), msg = root.querySelector("[data-bb-msg]"), sum = root.querySelector("[data-bb-sum]"), add = root.querySelector("[data-bb-add]");
    var max = Math.max(4, tiers.length ? tiers[tiers.length - 1].qty : 4);
    function card(id) { return root.querySelector('[data-bb-card][data-variant="' + id + '"]'); }
    function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.qty) t = x; }); return t; }
    function render() {
      var html = "";
      for (var i = 0; i < max; i++) {
        var id = picked[i], t = tiers.filter(function (x) { return x.qty === i + 1; })[0];
        if (id) { var c = card(id); html += '<li class="is-filled"><div class="yb-photo yb-photo--img"><img src="' + c.dataset.img + '" alt="' + c.dataset.title + '" loading="lazy"></div><button type="button" data-bb-unpick="' + id + '" aria-label="' + c.dataset.title + ' uit je bundel halen">×</button></li>'; }
        else html += '<li class="is-empty">' + (i + 1) + (t ? "<small>" + t.pct + "%</small>" : "") + "</li>";
      }
      slots.innerHTML = html;
      var sub = picked.reduce(function (a, id) { return a + (+card(id).dataset.price); }, 0), tier = tierFor(picked.length);
      var disc = tier ? picked.reduce(function (a, id) { return a + Math.floor(+card(id).dataset.price * tier.pct / 100); }, 0) : 0;
      var next = tiers.filter(function (x) { return picked.length < x.qty; })[0];
      msg.textContent = !picked.length ? "Kies hieronder je eerste set." : next ? "Nog " + (next.qty - picked.length) + " " + (next.qty - picked.length === 1 ? "set" : "sets") + " voor " + next.pct + "% bundelkorting." : "Top, je krijgt " + tier.pct + "% bundelkorting!";
      sum.innerHTML = picked.length ? "<div><dt>Subtotaal</dt><dd>" + money(sub) + "</dd></div>" + (disc ? "<div><dt>Bundelkorting " + tier.pct + "%</dt><dd>−" + money(disc) + "</dd></div>" : "") + "<div class=\"is-total\"><dt>Totaal</dt><dd>" + money(sub - disc) + "</dd></div>" : "";
      add.disabled = picked.length < 2;
      add.textContent = picked.length < 2 ? "Kies minstens 2 sets" : "Doe mijn " + picked.length + " sets in de winkelwagen";
      Array.prototype.forEach.call(root.querySelectorAll("[data-bb-pick]"), function (b) {
        var on = picked.indexOf(b.dataset.bbPick) > -1;
        b.setAttribute("aria-pressed", on); b.textContent = on ? "✓ In je bundel" : "Kies deze set";
        b.closest("[data-bb-card]").classList.toggle("is-on", on);
      });
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest("[data-bb-pick],[data-bb-unpick],[data-bb-age],[data-bb-add]"); if (!t) return;
      if (t.dataset.bbPick) { var i = picked.indexOf(t.dataset.bbPick); if (i > -1) picked.splice(i, 1); else if (picked.length < max) picked.push(t.dataset.bbPick); render(); }
      if (t.dataset.bbUnpick) { picked = picked.filter(function (x) { return x !== t.dataset.bbUnpick; }); render(); }
      if (t.dataset.bbAge !== undefined) {
        var r = t.dataset.bbAge.split("-");
        Array.prototype.forEach.call(root.querySelectorAll("[data-bb-age]"), function (b) { b.setAttribute("aria-pressed", b === t); });
        Array.prototype.forEach.call(root.querySelectorAll("[data-bb-card]"), function (c) {
          var show = !t.dataset.bbAge || (+c.dataset.ageMin <= +r[1] && +c.dataset.ageMax >= +r[0]);
          c.parentNode.hidden = !show;
        });
      }
      if (t.hasAttribute("data-bb-add") && picked.length >= 2 && window.YB && YB.addItems) {
        t.disabled = true;
        YB.addItems(picked.map(function (id) { return { id: +id, quantity: 1 }; }), { msg: "Je bundel staat in je winkelwagen" }).then(function () { picked = []; render(); }).catch(function () { t.disabled = false; });
      }
    });
    render();
  }
  (function (f) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", f); else f(); })(function () { Array.prototype.forEach.call(document.querySelectorAll("[data-yb-bundle]"), init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-cart-drawer"]) return;
  try {
    
(function () {
  function post(body) {
    var sections = ["yb-cart-drawer"];
    var main = document.querySelector("[data-cart-section]"); if (main) sections.push(main.dataset.cartSection);
    body.sections = sections.join(",");
    return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refresh(res) {
    if (!res || !res.sections) return;
    var d = document.getElementById("yb-cart"), wasOpen = d && d.dataset.open === "true";
    var details = d && d.querySelector(".yb-cd-code"), codeOpen = details && details.open;
    Object.keys(res.sections).forEach(function (id) {
      var el = document.getElementById("shopify-section-" + id); if (el && res.sections[id]) el.outerHTML = res.sections[id];
    });
    d = document.getElementById("yb-cart");
    if (d && wasOpen) { d.dataset.open = "true"; d.setAttribute("aria-hidden", "false"); }
    if (codeOpen) { var nd = d && d.querySelector(".yb-cd-code"); if (nd) nd.open = true; }
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = d.dataset.count; el.hidden = +d.dataset.count === 0; });
    document.dispatchEvent(new CustomEvent("yb:cart-updated"));
  }
  function renderCodes(list) {
    var ul = document.querySelector("[data-cd-codes]"); if (!ul || ul.children.length || !list || !list.length) return;
    ul.innerHTML = list.map(function (c) {
      var esc = String(c.code).replace(/[&<>"]/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]; });
      return '<li' + (c.applicable ? '' : ' class="is-na"') + '><span>' + esc + (c.applicable ? '' : ' · niet van toepassing') + '</span><button type="button" data-cd-code-remove="' + esc + '" aria-label="Code ' + esc + ' verwijderen">×</button></li>';
    }).join("");
    var det = ul.closest("details"); if (det) det.open = true;
  }
  function syncCodes() { fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { renderCodes(c.discount_codes); }).catch(function () {}); }
  document.addEventListener("yb:cart-updated", syncCodes);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", syncCodes); else syncCodes();
  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll("[data-cd-code-remove]"), function (b) { return b.dataset.cdCodeRemove; });
  }
  function msg(t, ok) { var m = document.querySelector("[data-cd-code-msg]"); if (m) { m.textContent = t; m.dataset.ok = ok ? "1" : "0"; } }
  document.addEventListener("submit", function (e) {
    var f = e.target.closest && e.target.closest("[data-cd-code-form]"); if (!f) return;
    e.preventDefault();
    var code = (f.code.value || "").trim(); if (!code) { msg("Vul een kortingscode in.", false); return; }
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }); codes.push(code);
    var btn = f.querySelector("button"); btn.disabled = true;
    post({ discount: codes.join(",") }).then(function (res) {
      var hit = (res.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      refresh(res);
      if (hit && hit.applicable) msg("Code " + hit.code + " is toegepast.", true);
      else msg("Deze code werkt niet voor je winkelwagen. Controleer de code of de voorwaarden.", false);
    }).catch(function () { msg("Toepassen lukte niet. Probeer het opnieuw.", false); btn.disabled = false; });
  });
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-cd-code-remove]"); if (!b) return;
    var codes = currentCodes().filter(function (c) { return c !== b.dataset.cdCodeRemove; });
    post({ discount: codes.join(",") }).then(refresh);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-gift-finder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("submit", function (e) {
  var f = e.target; if (!f.matches || !f.matches("[data-yb-giftfinder]")) return;
  /* "Maakt niet uit" niet meesturen; budget en exacte leeftijd worden op de collectiepagina toegepast */
  Array.prototype.forEach.call(f.querySelectorAll('[name="budget"]'), function (i) { if (i.checked && !i.value) i.disabled = true; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-main-cart"]) return;
  try {
    
document.addEventListener("change", function (e) {
  var t = e.target; if (!t.matches || !t.matches("#cart-note")) return;
  var body = { note: t.value };
  fetch((window.YB_CFG && YB_CFG.routes ? YB_CFG.routes.cart : "/cart") + "/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-main-collection"]) return;
  try {
    
(function () {
  function go(url) { window.location.href = url; }
  function build(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== "") p.append(k, v); });
    return location.pathname + "?" + p.toString();
  }
  document.addEventListener("change", function (e) {
    var f = e.target.closest("[data-yb-filter-form]");
    if (f) { go(build(f)); return; }
    if (e.target.matches("[data-yb-sort]")) {
      var p = new URLSearchParams(location.search); p.set("sort_by", e.target.value); p.delete("page");
      go(location.pathname + "?" + p.toString());
    }
  });
  document.addEventListener("submit", function (e) { var f = e.target.closest("[data-yb-filter-form]"); if (f) { e.preventDefault(); go(build(f)); } });
})();

/* Filteren in de browser (fallback zonder Search & Discovery), gelijk aan het prototype */
(function () {
  var AGES = [{ id: "0-2", label: "0–2 jaar", min: 0, max: 2 }, { id: "3-5", label: "3–5 jaar", min: 3, max: 5 }, { id: "6-8", label: "6–8 jaar", min: 6, max: 8 }, { id: "9plus", label: "9+ jaar", min: 9, max: 99 }];
  /* Grenzen inclusief: tot €15 = t/m €15,00; €15 – €25 = €15,01 t/m €25,00; €25 en meer = vanaf €25,01 */
  var BUDGETS = [{ id: "tot-15", label: "Tot €15", min: 0, max: 1500 }, { id: "15-25", label: "€15 – €25", min: 1501, max: 2500 }, { id: "25-plus", label: "€25 en meer", min: 2501, max: 1e9 }];
  function init() {
    var grid = document.querySelector("[data-yb-cf-grid]"); if (!grid || grid.dataset.cfReady) return; grid.dataset.cfReady = "1";
    var items = Array.prototype.map.call(grid.querySelectorAll("[data-cf-item]"), function (li) {
      var vp = (li.dataset.vp || "").split("|").filter(Boolean).map(function (x) { var a = x.split(":"); return { id: a[0], price: +a[1] }; });
      Array.prototype.forEach.call(li.querySelectorAll('a[href*="/products/"]'), function (a) { a.dataset.cfHref = a.getAttribute("href").replace(/([?&])variant=\d+&?/, "$1").replace(/[?&]$/, ""); });
      return { el: li, min: +li.dataset.min, max: +li.dataset.max, cat: li.dataset.cat, catLabel: li.dataset.catLabel, price: +li.dataset.price, vp: vp.length ? vp : [{ id: "", price: +li.dataset.price }], theme: (li.dataset.theme || "").toLowerCase() };
    });
    var promo = grid.querySelector("[data-cf-promo]");
    var cats = []; items.forEach(function (p) { if (p.cat && !cats.some(function (c) { return c.id === p.cat; })) cats.push({ id: p.cat, label: p.catLabel }); });
    var state = { age: [], cat: [], budget: [], theme: "", exact: null };
    /* Links van hero en cadeauzoeker: ?filter.p.m.yambillo.leeftijdsgroep=6–8 jaar&filter.p.m.yambillo.thema=Creatief&filter.v.price.gte=15&filter.v.price.lte=25 */
    var q = new URLSearchParams(location.search);
    q.getAll("filter.p.m.yambillo.leeftijdsgroep").forEach(function (v) { AGES.forEach(function (a) { if (a.label === v) state.age.push(a.id); }); });
    if (q.get("filter.p.m.yambillo.thema")) state.theme = q.get("filter.p.m.yambillo.thema").toLowerCase();
    /* Cadeauzoeker: exacte leeftijd. Een set past als de minimumleeftijd niet hoger is dan de leeftijd van het kind. */
    if (q.get("leeftijd") !== null && q.get("leeftijd") !== "" && !isNaN(+q.get("leeftijd"))) state.exact = Math.max(0, Math.min(18, parseInt(q.get("leeftijd"), 10)));
    q.getAll("categorie").forEach(function (c) { if (cats.some(function (x) { return x.id === c; })) state.cat.push(c); });
    q.getAll("budget").forEach(function (b) { if (by(BUDGETS, b) && state.budget.indexOf(b) === -1) state.budget.push(b); });
    /* Oude links met Shopify-prijsfilter: de server toont dan al een deelselectie */
    var gte = q.get("filter.v.price.gte"), lte = q.get("filter.v.price.lte"), serverFiltered = !!(gte || lte), startBudget = null;
    if (gte || lte) { var lo = gte ? Math.round(parseFloat(gte) * 100) : 0, hi = lte ? Math.round(parseFloat(lte) * 100) : 1e9; BUDGETS.forEach(function (b) { if (b.min >= lo - 1 && b.max <= hi) state.budget.push(b.id); }); }

    function by(list, id) { return list.filter(function (x) { return x.id === id; })[0]; }
    function inBudget(p, s) {
      if (!s.budget.length) return p.vp[0];
      return p.vp.filter(function (v) { return s.budget.some(function (id) { var b = by(BUDGETS, id); return v.price >= b.min && v.price <= b.max; }); })[0] || null;
    }
    function matches(p, s) {
      if (s.exact !== null && s.exact !== undefined && !(p.min <= s.exact && p.max >= s.exact)) return false;
      if (s.age.length && !s.age.some(function (id) { var a = by(AGES, id); return p.min <= a.max && p.max >= a.min; })) return false;
      if (s.cat.length && s.cat.indexOf(p.cat) === -1) return false;
      if (s.budget.length && !inBudget(p, s)) return false;
      if (s.theme && p.theme !== s.theme) return false;
      return true;
    }
    function countFor(key, val) { var s = JSON.parse(JSON.stringify(state)); s[key] = [val]; return items.filter(function (p) { return matches(p, s); }).length; }
    function esc(t) { var d = document.createElement("div"); d.textContent = t; return d.innerHTML; }
    function group(key, title, opts, sfx) {
      return '<div class="yb-filter-group"><fieldset><legend>' + title + "</legend>" + opts.map(function (o) {
        var id = "cf-" + key + "-" + o.id + "-" + sfx, n = countFor(key, o.id), on = state[key].indexOf(o.id) > -1;
        return '<label class="yb-check" for="' + id + '"><input type="checkbox" id="' + id + '" data-cf-key="' + key + '" value="' + o.id + '"' + (on ? " checked" : "") + (n === 0 && !on ? " disabled" : "") + "><span>" + esc(o.label) + "</span><span>" + n + "</span></label>";
      }).join("") + "</fieldset></div>";
    }
    function render() {
      Array.prototype.forEach.call(document.querySelectorAll("[data-yb-cf-panel]"), function (el) {
        var sfx = el.getAttribute("data-yb-cf-panel");
        el.innerHTML = group("age", "Leeftijd", AGES, sfx) + (cats.length > 1 ? group("cat", "Categorie", cats, sfx) : "") + group("budget", "Prijs", BUDGETS, sfx);
      });
      var chips = document.querySelector("[data-yb-cf-chips]");
      if (chips) chips.innerHTML = AGES.map(function (a) { return '<li><button class="yb-chip" type="button" data-cf-chip="' + a.id + '" aria-pressed="' + (state.age.indexOf(a.id) > -1) + '">' + a.label + " <small>(" + countFor("age", a.id) + ")</small></button></li>"; }).join("");
      var out = [];
      state.age.forEach(function (id) { out.push(["age", id, by(AGES, id).label]); });
      state.cat.forEach(function (id) { out.push(["cat", id, by(cats, id).label]); });
      state.budget.forEach(function (id) { out.push(["budget", id, by(BUDGETS, id).label]); });
      if (state.theme) out.push(["theme", state.theme, "Thema: " + state.theme.charAt(0).toUpperCase() + state.theme.slice(1)]);
      if (state.exact !== null) out.unshift(["exact", String(state.exact), state.exact === 0 ? "Jonger dan 1 jaar" : "Voor " + state.exact + " jaar"]);
      var act = document.querySelector("[data-yb-cf-active]");
      if (act) { act.innerHTML = out.map(function (o) { return '<button type="button" data-cf-unset="' + o[0] + '" data-val="' + o[1] + '" aria-label="Filter ' + esc(o[2]) + ' verwijderen">' + esc(o[2]) + ' <span aria-hidden="true">×</span></button>'; }).join("") + (out.length ? '<button type="button" data-cf-clear>Alles wissen</button>' : ""); act.hidden = !out.length; }
      var n = 0, visible = [];
      var groupMin = state.age.length ? Math.min.apply(null, state.age.map(function (id) { return by(AGES, id).min; })) : null;
      items.forEach(function (p) {
        var ok = matches(p, state); p.el.hidden = !ok; if (ok) { n++; visible.push(p.el); }
        /* Juiste variant: bij een budget linkt de kaart naar een koopbare variant binnen dat budget */
        var v = inBudget(p, state);
        Array.prototype.forEach.call(p.el.querySelectorAll("a[data-cf-href]"), function (a) { var h = a.dataset.cfHref; a.setAttribute("href", state.budget.length && v && v.id ? h + (h.indexOf("?") > -1 ? "&" : "?") + "variant=" + v.id : h); });
        /* Brede leeftijdsgroep: maak zichtbaar dat een set pas vanaf een hogere leeftijd geschikt is */
        var note = p.el.querySelector("[data-cf-agenote]");
        var show = groupMin !== null && state.exact === null && p.min > groupMin;
        if (show && !note) { note = document.createElement("p"); note.className = "yb-cf-agenote"; note.setAttribute("data-cf-agenote", ""); var t = p.el.querySelector(".yb-card__title"); (t ? t.parentNode : p.el).insertBefore(note, t ? t.nextSibling : null); }
        if (note) { note.hidden = !show; if (show) note.textContent = "Let op: geschikt vanaf " + p.min + " jaar"; }
      });
      if (promo) { if (visible.length > 6) { visible[5].after(promo); promo.hidden = false; } else { promo.hidden = true; } }
      var empty = document.querySelector("[data-yb-cf-empty]"); if (empty) empty.hidden = n > 0;
      var widen = document.querySelector("[data-cf-widen]"); if (widen) widen.hidden = !state.budget.length;
      var c = document.querySelector("[data-yb-cf-count]"); if (c) c.textContent = n + (n === 1 ? " product" : " producten");
      var ap = document.querySelector("[data-yb-cf-apply]"); if (ap) ap.textContent = "Toon " + n + (n === 1 ? " product" : " producten");
      syncUrl();
    }
    /* Filterstatus in de URL, zodat verversen, terugknop, sorteren en delen dezelfde selectie tonen */
    function syncUrl() {
      if (!window.history || !history.replaceState) return;
      var u = new URL(location.href);
      ["leeftijd", "filter.p.m.yambillo.thema", "filter.p.m.yambillo.leeftijdsgroep", "filter.v.price.gte", "filter.v.price.lte", "budget", "categorie", "page"].forEach(function (k) { u.searchParams.delete(k); });
      if (state.exact !== null) u.searchParams.set("leeftijd", state.exact);
      state.age.forEach(function (id) { u.searchParams.append("filter.p.m.yambillo.leeftijdsgroep", by(AGES, id).label); });
      state.cat.forEach(function (id) { u.searchParams.append("categorie", id); });
      if (state.theme) u.searchParams.set("filter.p.m.yambillo.thema", state.theme.charAt(0).toUpperCase() + state.theme.slice(1));
      state.budget.forEach(function (id) { u.searchParams.append("budget", id); });
      var next = u.pathname + (u.searchParams.toString() ? "?" + u.searchParams.toString() : "") + u.hash;
      if (startBudget === null) startBudget = state.budget.join(",");
      /* Pagina kwam al gefilterd van de server en het budget verandert: opnieuw laden met alle producten */
      if (serverFiltered && state.budget.join(",") !== startBudget) { location.href = next; return; }
      history.replaceState(null, "", next);
    }
    document.addEventListener("change", function (e) {
      var t = e.target; if (!t.dataset || !t.dataset.cfKey) return;
      var arr = state[t.dataset.cfKey], i = arr.indexOf(t.value);
      if (t.checked && i === -1) arr.push(t.value); if (!t.checked && i > -1) arr.splice(i, 1);
      var id = t.id; render(); var again = document.getElementById(id); if (again) again.focus();
    });
    document.addEventListener("click", function (e) {
      var c = e.target.closest("[data-cf-chip],[data-cf-unset],[data-cf-clear]"); if (!c) return;
      if (c.dataset.cfChip) { var i = state.age.indexOf(c.dataset.cfChip); if (i > -1) state.age.splice(i, 1); else state.age.push(c.dataset.cfChip); }
      if (c.dataset.cfUnset) { if (c.dataset.cfUnset === "exact") state.exact = null; else if (c.dataset.cfUnset === "budget-all") state.budget = []; else if (c.dataset.cfUnset === "theme") state.theme = ""; else state[c.dataset.cfUnset] = state[c.dataset.cfUnset].filter(function (v) { return v !== c.dataset.val; }); }
      if (c.dataset.cfClear !== undefined) state = { age: [], cat: [], budget: [], theme: "", exact: null };
      render();
    });
    render();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-main-product"]) return;
  try {
    
(function () {
  function init(root) {
    var data = JSON.parse(document.querySelector("[data-product-json]").textContent);
    var money = function (c) { return window.YB && YB.money ? YB.money(c) : (c / 100).toFixed(2); };
    var allThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-shot]")), thumbs = [], cur = 0;
    var main = root.querySelector("[data-gmain]"), count = root.querySelector("[data-gcount]");
    var gallery = root.querySelector(".yb-gallery"), grouped = gallery && gallery.hasAttribute("data-grouped");
    function setGroup(key) {
      thumbs = [];
      allThumbs.forEach(function (b) {
        var g = b.dataset.group || "", on = !grouped || !g || g === key;
        b.parentNode.hidden = !on;
        if (on) { thumbs.push(b); b.setAttribute("aria-label", "Toon foto " + thumbs.length); }
      });
      var many = thumbs.length > 1;
      Array.prototype.forEach.call(root.querySelectorAll("[data-gnav]"), function (n) { n.hidden = !many; });
      var wrap = root.querySelector("[data-thumbs-wrap]"); if (wrap) wrap.hidden = !many;
      if (count) count.hidden = !many;
    }
    function show(i) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      var t = thumbs[cur];
      main.innerHTML = '<div class="yb-photo yb-photo--img"><img src="' + t.dataset.src + '" alt="' + t.dataset.alt + '" width="1200" height="1200"></div>';
      if (count) count.textContent = (cur + 1) + " / " + thumbs.length;
      allThumbs.forEach(function (b) { b.setAttribute("aria-current", b === t); });
      var ul = t.closest("ul"), li = t.parentNode;
      if (ul.scrollWidth > ul.clientWidth) ul.scrollTo({ left: li.offsetLeft - (ul.clientWidth - li.offsetWidth) / 2, behavior: "smooth" });
    }
    thumbs = allThumbs.filter(function (b) { return !b.parentNode.hidden; });
    thumbs.forEach(function (t, j) { if (t.getAttribute("aria-current") === "true") cur = j; });
    root.addEventListener("click", function (e) {
      var s = e.target.closest("[data-shot]"); if (s) show(thumbs.indexOf(s));
      var g = e.target.closest("[data-gnav]"); if (g) show(cur + (+g.dataset.gnav));
      var q = e.target.closest("[data-qty]");
      if (q) { var inp = root.querySelector('[name="quantity"]'); inp.value = Math.max(1, Math.min(20, (+inp.value || 1) + (+q.dataset.qty))); }
    });
    var x0 = null, gm = root.querySelector(".yb-gallery__main");
    if (gm) {
      gm.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
    }
    root.addEventListener("change", function (e) {
      if (!e.target.dataset || e.target.dataset.option === undefined) return;
      var sel = [];
      Array.prototype.forEach.call(root.querySelectorAll("[data-option]:checked"), function (r) { sel[+r.dataset.option] = r.value; });
      var out = root.querySelector('[data-option-out="' + e.target.dataset.option + '"]'); if (out) out.textContent = e.target.value;
      var v = data.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
      var btn = root.querySelector("[data-add-main]");
      if (!v) { btn.disabled = true; btn.textContent = "Niet beschikbaar"; return; }
      root.querySelector("[data-variant-id]").value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? "In winkelwagen" : "Uitverkocht";
      var p = root.querySelector("[data-price]"), small = p.querySelector("small").outerHTML;
      p.innerHTML = money(v.price) + (v.compare > v.price ? ' <s><span class="yb-sr">was </span>' + money(v.compare) + "</s>" : "") + small;
      var sp = document.querySelector("[data-sticky-price]"); if (sp) sp.textContent = money(v.price);
      var st = root.querySelector("[data-stock]"); if (st) { st.textContent = v.low ? "● Nog " + v.low + " op voorraad" : (v.available ? "● Op voorraad" : "Tijdelijk uitverkocht"); st.classList.toggle("yb-stock--low", !!v.low); }
      if (window.YBtiers) window.YBtiers(v.price);
      var sku = root.querySelector("[data-sku]"); if (sku) sku.textContent = v.sku || "";
      var ean = root.querySelector("[data-ean]"); if (ean) ean.textContent = v.barcode || "";
      if (grouped) setGroup(v.title);
      var mi = 0; thumbs.forEach(function (t, j) { if (+t.dataset.mediaId === v.media) mi = j; }); if (grouped || v.media) show(mi);
      var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    });
    var tiers = root.querySelector("[data-yb-tiers]"), qtyIn = root.querySelector('[name="quantity"]');
    if (tiers) {
      var tierPct = function (q) { var d = tiers.dataset; q = +q; return q >= +d.q3 ? +d.p3 : (q >= +d.q2 ? +d.p2 : (q >= +d.q1 ? +d.p1 : 0)); };
      window.YBtiers = function (price) {
        Array.prototype.forEach.call(tiers.querySelectorAll("[data-tier-price]"), function (el) { var q = +el.dataset.tierPrice; el.textContent = money(q * (price - Math.floor(price * tierPct(q) / 100))); });
        Array.prototype.forEach.call(tiers.querySelectorAll("[data-tier-was]"), function (el) { el.textContent = money(price * +el.dataset.tierWas); });
      };
      tiers.addEventListener("change", function (e) { if (e.target.name === "yb-tier") qtyIn.value = e.target.value; });
      qtyIn.addEventListener("change", function () { Array.prototype.forEach.call(tiers.querySelectorAll('[name="yb-tier"]'), function (r) { r.checked = +r.value === +qtyIn.value; }); });
      root.addEventListener("click", function (e) { if (e.target.closest("[data-qty]")) Array.prototype.forEach.call(tiers.querySelectorAll('[name="yb-tier"]'), function (r) { r.checked = +r.value === +qtyIn.value; }); });
    }
    var pairs = root.querySelector("[data-yb-pairs]");
    if (pairs) {
      var calc = function () {
        var sum = +pairs.dataset.mainPrice, n = 1;
        Array.prototype.forEach.call(pairs.querySelectorAll("input:checked"), function (c) { sum += +c.dataset.price; n++; });
        pairs.querySelector("[data-pairs-sum]").textContent = money(sum);
        pairs.querySelector("[data-pairs-add]").textContent = n > 1 ? "Doe ze alle " + n + " in mijn winkelwagen" : "In mijn winkelwagen";
      };
      pairs.addEventListener("change", calc); calc();
      pairs.querySelector("[data-pairs-add]").addEventListener("click", function () {
        var items = [{ id: +root.querySelector("[data-variant-id]").value, quantity: 1 }];
        Array.prototype.forEach.call(pairs.querySelectorAll("input:checked"), function (c) { items.push({ id: +c.value, quantity: 1 }); });
        if (window.YB && YB.addItems) YB.addItems(items);
      });
    }
    var bar = document.querySelector("[data-sticky-buy]"), buy = root.querySelector("#yb-buy");
    if (bar && buy && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; bar.dataset.show = show; bar.setAttribute("aria-hidden", !show); }).observe(buy);
    }
  }
  (function (f) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", f); else f(); })(function () { var r = document.querySelector("[data-yb-product]"); if (r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp() {
    Array.prototype.forEach.call(document.querySelectorAll(".yb-rev:not([hidden]) .yb-rev__text"), function (p) {
      var btn = p.parentNode.querySelector("[data-rev-toggle]"); if (!btn || p.closest(".yb-rev").classList.contains("is-open")) return;
      btn.style.visibility = p.scrollHeight > p.clientHeight + 2 ? "visible" : "hidden";
    });
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-rev-toggle]");
    if (t) {
      var card = t.closest(".yb-rev"), open = card.classList.toggle("is-open");
      t.setAttribute("aria-expanded", open); t.textContent = open ? "Minder tonen" : "Lees verder";
      return;
    }
    var b = e.target.closest && e.target.closest("[data-revs-more]"); if (!b) return;
    var more = document.querySelectorAll("[data-rev-more]");
    Array.prototype.forEach.call(more, function (li) { li.hidden = false; });
    if (more[0]) { var h = more[0].querySelector("h3, p"); if (h) { h.setAttribute("tabindex", "-1"); h.focus(); } }
    b.remove(); clamp();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", clamp); else clamp();
  addEventListener("resize", clamp);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-promo-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.querySelector("[data-yb-promo]"); if (!el) return;
  var end = +el.dataset.end, t = el.querySelector("[data-promo-timer]");
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function tick() {
    var ms = end - Date.now();
    if (ms <= 0) { el.hidden = true; clearInterval(iv); return; }
    if (!t) return;
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    t.textContent = (d ? d + (d === 1 ? " dag " : " dagen ") : "") + pad(h) + ":" + pad(m) + ":" + pad(x);
  }
  var iv = setInterval(tick, 1000); tick();
  var b = el.querySelector("[data-promo-copy]");
  b.addEventListener("click", function () {
    var code = b.dataset.promoCopy, st = b.querySelector("[data-promo-status]");
    var done = function () { b.classList.add("is-copied"); st.textContent = "Code " + code + " gekopieerd"; if (window.YB && YB.toast) YB.toast("Code " + code + " gekopieerd. Vul hem in bij je winkelwagen of bij het afrekenen."); setTimeout(function () { b.classList.remove("is-copied"); st.textContent = ""; }, 2500); };
    try { navigator.clipboard.writeText(code).then(done, done); } catch (e) { done(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
